// @flow
import $ from 'jquery'
import _ from 'lodash'
import React, { Component } from 'react'
import className from 'classnames'
import Modal from 'react-responsive-modal'
import ShowtimeGeometry from './showtime_geometry'
import RectArea from './RectArea'
import { linkColor } from '../controls/colors'
import styled from 'styled-components'

const gridColor = '#bbb'
const onColor = '#a3f09f'
const offColor = '#f8f8f8'
const selectorOffColor = 'white'
const selectorOffTextColor = linkColor
const selectorOnColor = 'white'
const selectorOnMarkColor = '#8ac'
const selectorOnTextColor = 'black'
const selectorMarkWidth = '5px'

const Wrapper = styled.div`
  .showtime-dialog__table-background {
    background-color: white;
    border-radius: 5px;
    user-select: none;
  }

  .showtime-dialog__table-title {
    font-size: 20px;
    color: #000;
    font-weight: bold;
    margin-bottom: 25px;
  }

  .showtime-dialog__table {
    border-style: none;
    border-collapse: collapse;
    margin: 20px auto;
  }

  .showtime-dialog__corner-cell {
    box-sizing: border-box;
    border-top: solid 1px ${gridColor};
    border-right: solid 1px ${gridColor};
  }

  .showtime-dialog__clickable {
    cursor: pointer;
  }

  .showtime-dialog__row-header {
    box-sizing: border-box;
    width: 55px;
    position: relative;
    border-top: solid 1px ${gridColor};
    border-right: solid 1px ${gridColor};
  }

  .showtime-dialog__row-header-text {
    padding: 8px;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    border-left: solid ${selectorMarkWidth} transparent;
    border-right: solid ${selectorMarkWidth} transparent;
  }

  .showtime-dialog__row-header_on {
    .showtime-dialog__row-header-text {
      border-left: solid ${selectorMarkWidth} ${selectorOnMarkColor};
      border-right: solid ${selectorMarkWidth} transparent;
    }
  }

  .showtime-dialog__col-header {
    box-sizing: border-box;
    border-top: solid 1px ${gridColor};
    border-right: solid 1px ${gridColor};
    height: 60px;
    max-width: 30px;
    border-bottom: solid ${selectorMarkWidth} ${selectorOffColor};
  }

  .showtime-dialog__col-header_on {
    border-bottom: solid ${selectorMarkWidth} ${selectorOnMarkColor};
  }

  .showtime-dialog__col-header-text {
    position: relative;
    top: 5px;

    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  }

  .showtime-dialog__selector {
    background-color: ${selectorOffColor};
    color: ${selectorOffTextColor};
    white-space: nowrap;
  }

  .showtime-dialog__selector_on {
    background-color: ${selectorOnColor};
    color: ${selectorOnTextColor};
  }

  .showtime-dialog__hour {
    box-sizing: border-box;
    border-top: solid 1px ${gridColor};
    border-right: solid 1px ${gridColor};
    background-color: ${offColor};
    height: 30px;
    text-align: center;
    width: 30px;
  }

  .showtime-dialog__hour_on {
    background-color: ${onColor};
  }

  @media (max-width: 850px) {
    .showtime-dialog__table {
      font-size: 12px;
    }
    .showtime-dialog__hour {
      height: 25px;
      width: 25px;
    }
    .showtime-dialog__col-header {
      max-width: 25px;
      height: 50px;
    }
    .showtime-dialog__row-header {
      max-height: 25px;
      width: 35px;
      min-width: 35px;
    }
  }

  @media (max-width: 730px) {
    .showtime-dialog__table {
      font-size: 9px;
    }
    .showtime-dialog__hour {
      height: 20px;
      width: 20px;
    }
    .showtime-dialog__col-header {
      max-width: 20px;
      height: 40px;
    }
    .showtime-dialog__row-header {
      max-height: 20px;
      width: 35px;
      min-width: 35px;
    }
  }

  @media (max-width: 580px) {
    .showtime-dialog__table {
      font-size: 7px;
    }
    .showtime-dialog__table-background {
      padding: 5px;
    }
    .showtime-dialog__hour {
      height: 15px;
      width: 15px;
    }
    .showtime-dialog__col-header {
      max-width: 15px;
      height: 30px;
    }
    .showtime-dialog__row-header {
      max-height: 15px;
      width: 25px;
      min-width: 25px;
    }
  }
`

type Props = {|
  translateFunction: Function,
  isOpen: boolean,
  onClose?: () => void,
  value: Array<Array<number>>,
  onChange: (Array<Array<number>>) => void
|}

export default class ShowtimeDialog extends Component<Props> {
  cellElements: any
  t: Function

  constructor(props: Props) {
    super(props)

    this.t = props.translateFunction
    this.cellElements = _.times(7, () => _.times(24))
  }

  render() {
    return (
      <Modal open={this.props.isOpen} onClose={() => this.close()}>
        <RectArea
          onSelect={(x1, y1, x2, y2) => this.areaSelected(x1, y1, x2, y2)}
          mouseDownSelector=".showtime-dialog__hour"
        />
        <Wrapper>
          <div className="showtime-dialog__table-title">{this.t('edit_timetable')}</div>
          <table className="showtime-dialog__table">{this.renderTableBody()}</table>
          <button className="blue-button" onClick={() => this.close()}>
            {this.t('finish_edit')}
          </button>
        </Wrapper>
      </Modal>
    )
  }

  renderTableBody() {
    return (
      <tbody>
        {_.map(this.showtimeDays(), (day, dayIndex) => (
          <tr key={dayIndex}>
            <th
              className={this.rowHeaderClass(dayIndex)}
              onClick={() => this.rowHeaderClicked(dayIndex)}
            >
              <div className="showtime-dialog__row-header-text">{day}</div>
            </th>
            {this.showtimeHours().map((_, hourIndex) => (
              <td
                key={hourIndex}
                className={this.cellClass(dayIndex, hourIndex)}
                ref={(el) => {
                  this.cellElements[dayIndex][hourIndex] = el
                }}
              />
            ))}
          </tr>
        ))}
        <tr>
          <th className="showtime-dialog__corner-cell" />
          {_.map(this.showtimeHours(), (interval, hourIndex) => (
            <th
              key={hourIndex}
              className={this.colHeaderClass(hourIndex)}
              onClick={() => this.colHeaderClicked(hourIndex)}
            >
              <div className="showtime-dialog__col-header-text">{interval}</div>
            </th>
          ))}
        </tr>
      </tbody>
    )
  }

  close() {
    this.props.onClose && this.props.onClose()
  }

  areaSelected(x1: number, y1: number, x2: number, y2: number) {
    let value = _.cloneDeep(this.props.value)

    let selectedItems = []
    _.times(7, (dayIndex) => {
      _.times(24, (hourIndex) => {
        let el = this.cellElements[dayIndex][hourIndex]
        if (this.isCrossed(el, x1, y1, x2, y2)) selectedItems.push({ dayIndex, hourIndex })
      })
    })
    if (selectedItems.length === 1) {
      let item = selectedItems[0]
      let dayIndex = item.dayIndex
      let hourIndex = item.hourIndex
      if (_.includes(value[dayIndex], hourIndex)) {
        value[dayIndex] = _.without(value[dayIndex], hourIndex)
      } else {
        value[dayIndex] = _.sortBy(_.uniq(_.concat(value[dayIndex], hourIndex)))
      }
    } else if (selectedItems.length > 1) {
      value = _.times(7, () => [])
      _.each(selectedItems, (item) => {
        let dayIndex = item.dayIndex
        let hourIndex = item.hourIndex

        value[dayIndex].push(hourIndex)
      })
    }

    this.valueChanged(value)
  }

  isCrossed(el: any, x1: number, y1: number, x2: number, y2: number) {
    let $el = $(el)
    return new ShowtimeGeometry().rectanglesAreCrossed(
      x1,
      y1,
      x2,
      y2,
      $el.offset().left,
      $el.offset().top,
      $el.offset().left + $el.width(),
      $el.offset().top + $el.height()
    )
  }

  valueChanged(value: Array<Array<number>>) {
    this.props.onChange && this.props.onChange(value)
  }

  rowHeaderClicked(dayIndex: number) {
    let value = _.cloneDeep(this.props.value)
    let row = value[dayIndex]

    row = this.rowHeaderSelected(dayIndex) ? [] : _.times(24)
    value[dayIndex] = row

    this.valueChanged(value)
  }

  colHeaderClicked(hourIndex: number) {
    let value = _.cloneDeep(this.props.value)

    if (this.colHeaderSelected(hourIndex)) {
      value = _.map(value, (row) => _.without(row, hourIndex))
    } else {
      value = _.map(value, (row) => _.sortBy(_.uniq(_.concat(row, hourIndex))))
    }

    this.valueChanged(value)
  }

  rowHeaderClass(dayIndex: number) {
    return className(
      'showtime-dialog__row-header showtime-dialog__selector showtime-dialog__clickable',
      { 'showtime-dialog__row-header_on': this.rowHeaderSelected(dayIndex) }
    )
  }

  rowHeaderSelected(dayIndex: number) {
    return _.size(this.props.value[dayIndex]) === 24
  }

  colHeaderClass(hourIndex: number) {
    return className(
      'showtime-dialog__col-header showtime-dialog__selector showtime-dialog__clickable',
      { 'showtime-dialog__col-header_on': this.colHeaderSelected(hourIndex) }
    )
  }

  colHeaderSelected(hourIndex: number) {
    return _.every(this.props.value, (hours) => _.includes(hours, hourIndex))
  }

  cellClass(dayIndex: number, hourIndex: number) {
    return className('showtime-dialog__hour showtime-dialog__clickable', {
      'showtime-dialog__hour_on': _.includes(this.props.value[dayIndex], hourIndex)
    })
  }

  showtimeHours(): Array<string> {
    return _.times(24, (hour) => {
      let from = hour
      let to = (hour + 1) % 24
      let format = (num) => _.padStart(num.toString(), 2, '0')

      return format(from) + '..' + format(to)
    })
  }

  showtimeDays(): Array<string> {
    return _.map(
      ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
      (day) => this.t(day)
    )
  }
}
